import { useMemo } from 'react';
import StarEmpty from '@svg/poi-modal/star_empty.svg';
import StarHalf from '@svg/poi-modal/star_half.svg';
import StarFull from '@svg/poi-modal/star_full.svg';
import CircleEmpty from '@svg/poi-modal/circle_empty.svg';
import CircleFull from '@svg/poi-modal/circle_full.svg';
import CircleHalf from '@svg/poi-modal/circle_half.svg';

export default function Stars({ type, rating }: { type: 'google' | 'tripadvisor'; rating: string }) {
  const ratingTypes = useMemo(() => {
    if (!rating) return [];
    const floatRating = parseFloat(rating);

    return Array.from(Array(5)).map((_, idx) => {
      if (floatRating >= idx + 1) return 'full';
      else if (floatRating >= idx + 0.5) return 'half';
      return 'empty';
    });
  }, [rating]);

  return (
    <div className='flex items-center'>
      {ratingTypes.map((ratingType, idx) => {
        if (type === 'google') {
          if (ratingType === 'full') return <StarFull key={idx} />;
          else if (ratingType === 'half') return <StarHalf key={idx} />;
          return <StarEmpty key={idx} />;
        } else {
          if (ratingType === 'full') return <CircleFull key={idx} className='mx-2pxr' />;
          else if (ratingType === 'half') return <CircleHalf key={idx} className='mx-2pxr' />;
          return <CircleEmpty key={idx} className='mx-2pxr' />;
        }
      })}
    </div>
  );
}
